// extracted by mini-css-extract-plugin
module.exports = {"salaryChartTooltip":"salaryChartTooltip_salaryChartTooltip__Z_DaQ","majorVersion":"salaryChartTooltip_majorVersion__L0ol_"};